import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';

export interface LoaderProps {
  loading: boolean;
  size?: number;
  color?: string;
  center?: boolean;
  children?: () => JSX.Element;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({
  loading,
  size = 50,
  color = '#522583',
  center,
  className,
  children = () => null,
}) => {
  const classes = useStyles();
  return loading ? (
    <div className={clsx({ [classes.center]: center }, className)}>
      <ClipLoader  size={size} color={color} />
    </div>
  ) : (
      children()
    );
};

const useStyles = createUseStyles({
  center: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',

  },
});

export default Loader;
